export default {
  all: {
    value: 'all',
    name: 'Wszyscy',
  },
  minors: {
    value: 'minors',
    name: 'Osoby niepełnoletnie',
  },
  adults: {
    value: 'adults',
    name: 'Osoby pełnoletnie',
  },
};


// WEBPACK FOOTER //
// ./src/constants/approvalConstraints.js